import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import Breadcrumb from "src/components/layouts/Common/Breadcrumb";
import Sidebar from "src/components/layouts/sidebar/Sidebar";
import AgeGroup from "src/components/panel/meal/age-groups/AgeGroups";

const AgeGroupsView: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t("meal_age_groups_list_tab")}</title>
      </Helmet>
      <Sidebar>
        <Breadcrumb
          title={t("meal_age_groups_list_title")}
          subtitle={t("meal_age_groups_list_subtitle")}
        />
        <AgeGroup />
      </Sidebar>
    </>
  );
};

export default AgeGroupsView;
